import $ from 'jquery'

const debug = require('debug')('pm:ajax-error')

const STATUS_UNAUTHORIZED = 401

$(document).ajaxError((event, jqXHR, _settings, thrownError) => {
  debug('handling error', { event, jqXHR, thrownError })
  if (jqXHR.status === STATUS_UNAUTHORIZED) {
    debug('reloading the page')
    // this should force the browser to navigate to the login page
    location.reload()
  }
})

export function extractMessageFromAjaxFailure(
  jqXHR: JQueryXHR,
  fallback = 'Unknown error'
) {
  return (jqXHR.responseJSON && jqXHR.responseJSON.message) || fallback
}
